import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { ProyectService } from '../../components/proyect.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CheckchildGuard implements CanActivate, CanActivateChild {

  flag: boolean;
  constructor(private _service: ProyectService, private router: Router) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this._service.existeSession()
      .then(res => {
        debugger
        if (this.flag === false) {
          this.router.navigate(['/']);
          return false;
        }
        return true;
      })
      .catch(err => {
        console.log('error: ', err);
        return false;
      })
    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    return false;

  }

}
